// Main flow of control

import Promise from 'bluebird';

import controllersWrapper from './controllers';
import parsers from '../parsers';
import models from '../models';
import renderers from '../renderers';
import ParserWrapper from './parser';
import ModelWrapper from './model';
import RendererWrapper from './renderer';
import leechWrapper from './leech';

export default (_Topics, _meta) => {
  const Topics = Promise.promisifyAll(_Topics);
  const settings = Promise.promisifyAll(_meta.settings);
  const Parser = ParserWrapper(parsers);
  const Renderer = RendererWrapper(renderers);
  const Model = ModelWrapper(models, Renderer);
  const handle = data => Promise.resolve(data)
    .then(Parser.parse)
    .then(Model.test)
    .then(Renderer.render);
  const leech = leechWrapper(Topics, settings, handle);
  const controllers = controllersWrapper(Model, leech);

  return (params, callback) => {
    const router = params.router;
    // const app = params.app;
    const hostMiddleware = params.middleware;
    // const hostControllers = params.controllers;

    router.post('/api/leech-tool', controllers.leechToolAPI);

    // We create two routes for every view. One API call, and the actual route itself.
    // Just add the buildHeader middleware to your route and NodeBB will take care
    // of everything for you.

    router.get('/admin/plugins/leech-tool', hostMiddleware.admin.buildHeader, controllers.renderAdminPage);
    router.get('/api/admin/plugins/leech-tool', controllers.renderAdminPage);

    callback();
  };
};
